import { render, staticRenderFns } from "./Octave.vue?vue&type=template&id=087acd99&scoped=true&"
import script from "./Octave.vue?vue&type=script&lang=js&"
export * from "./Octave.vue?vue&type=script&lang=js&"
import style0 from "./Octave.vue?vue&type=style&index=0&id=087acd99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087acd99",
  null
  
)

export default component.exports